import React from "react";
import Card from "../componentLibrary/Card";
import Skeleton from "../componentLibrary/Skeleton";
import getClassName from "../componentLibrary/utils/combineClassName";

export default function LoadingCard({ className }: { className?: string }) {
  return (
    <div className="inline-block w-full">
      <Card color="#CEEDF9" className={getClassName(["w-full", className])}>
        <Skeleton color="bg-electrum-200" size="large" rows={3} avatar />
      </Card>
    </div>
  );
}
